import { validatorRequire, validatorRequireNumber } from '@/utils/validators';
import InputNumber from '@/components/DSE/InputNumber';
import DatePicker from '@/components/DSE/DatePicker';
import PickRec from '@/components/DSE/PickRec/src/PickRec';
import MDinput from '@/components/MDinput';
export function getFormDefinition(vue) {
  return {
    countryID: {
      type: PickRec,
      defaultValue: null,
      props: {
        caption: 'vat.countryID',
        valueField: 'id',
        labelField: 'code',
        inputField: 'name',
        maxlength: 64,
        columns: [
          { field: 'code', label: 'common.code' },
          { field: 'name', label: 'common.name' }
        ],
        entity: 'Country',
        required: true,
        usePagination: true,
        hideInput: false,
        suggest: true
      },
      rules: [
        {
          validator: validatorRequire
        }
      ]
    },
    vatPercentage: {
      type: InputNumber,
      defaultValue: undefined,
      props: {
        min: 0,
        max: 100,
        precision: 1,
        step: 0.5,
        caption: 'vat.vatPercentage'
      },
      rules: [
        {
          validator: validatorRequireNumber
        }
      ]
    },
    glCodeSales: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 8,
        caption: 'vat.glCodeSales'
      }
    },
    glCodePurchase: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 8,
        caption: 'vat.glCodePurchase'
      }
    },
    startAt: {
      type: DatePicker,
      props: {
        caption: 'vat.startDate',
        showWeekNumbers: false
      },
      rules: [
        {
          validator: validatorRequire
        }
      ]
    }
  };
}

export default getFormDefinition;

export function createItemFromFormData(vue, form) {
  const item = { ...form, startDate: form.startAt };
  delete item.startAt;
  return item;
}

export function createFormDataFromItem(vue, item) {
  const form = { ...item, startAt: item.startDate };
  delete form.startDate;
  return form;
}
